/* assets/magnify2.js — v4: Panel out from slider + fallback overlay */
(function(){
  // Root of the main slider according to your HTML:
  // <div class="pdp-slider-main"> ... <div class="slider-images"> ... </div>
  const ROOT_CANDIDATES = ['.slider-images', '.product__media-wrapper', 'media-gallery'];
  const ACTIVE_IMG_CANDIDATES = [
  '.swiper-slide-active .image-magnify-hover',
  '.swiper-slide-active .slider-image img.image-magnify-hover',
  '.swiper-slide-active .slider-image img'
];

  const ZOOM = 2.21; // base scale (200%); adjust 2–3 for more/less zoom
  const preview = document.getElementById('zoom-container'); // if it exists, we will use the panel

  const __rootState = new WeakMap();
  function __getRootState(root){
    let s = __rootState.get(root);
    if (!s){
      s = { currentImg: null };
      __rootState.set(root, s);
    }
    return s;
  }

  /* --- Cursor Lens helpers (added) --- */
  let __lens = null;
  function __ensureLens(){
    if (__lens) return __lens;
    __lens = document.createElement('div');
    __lens.className = 'zoom-lens';
    document.body.appendChild(__lens);
    return __lens;
  }
  function __showLens(){ if (__lens) __lens.style.display = 'block'; }
  function __hideLens(){ if (__lens) __lens.style.display = 'none'; }
  /* --- end helpers cursor lens --- */

  function hiRes(src){
    if(!src) return '';
    // Keeps //cdn... and only changes the size suffix if it exists
    return src.replace(/_(\d+x\d+|\d+x|x\d+)\.(jpg|jpeg|png|webp|avif)(\?.*)?$/i, '_2048x.$2$3');
  }

  function pickRoot(){
    for (const s of ROOT_CANDIDATES){
      const el = document.querySelector(s);
      if (el) return el;
    }
    return document.body;
  }

  function pickActiveImg(root){
    for (const s of ACTIVE_IMG_CANDIDATES){
      const img = root.querySelector(s);
      if (img) return img;
    }
    return null;
  }

  function posIn(el, clientX, clientY){
    const r = el.getBoundingClientRect();
    return {
      px: Math.max(0, Math.min(1, (clientX - r.left) / r.width)),
      py: Math.max(0, Math.min(1, (clientY - r.top) / r.height)),
    };
  }

  // === Align zoom panel to the product info column (left edge + small gutter)
  function alignZoomToInfo(panel){
    const info = document.querySelector('.product__info-container');
    if (!panel || !info) return;

    const r = info.getBoundingClientRect();
    const cs = getComputedStyle(info);
    const padLeft = parseFloat(cs.paddingLeft || '0');
    const gutter = 12; // px separation from text edge

    // Adjust position to the left edge of the info-container
    panel.style.left = (r.left) + 'px';
    panel.style.top  = r.top + 'px';

    // Limits max width so it never exceeds the image right edge
    const maxW = Math.max(320, Math.min(panel.offsetWidth || 520, r.width - padLeft - gutter));
    panel.style.maxWidth = maxW + 'px';
  }

  // --- helper: returns the active image under the pointer or null ---
  function imgUnderPointer(root, e){
    // using the same strategy that you already have to find the active image
    const img = pickActiveImg(root);
    if (!img) return null;
    const r = img.getBoundingClientRect();
    const t = e && (e.touches ? e.touches[0] : e);
    const x = t?.clientX ?? 0, y = t?.clientY ?? 0;
    return (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) ? img : null;
  }

  /* ============ PANEL MODE (preferred) ============ */
  function panelAttach(img){
    if (!preview) return false;
    if (preview.parentNode !== document.body) {
      document.body.appendChild(preview);
    }
    const src = img.currentSrc || img.src || '';
    const big = hiRes(src) || src;
    preview.style.backgroundImage = `url("${big}")`;
    const scalePct = Math.max(200, Math.min(350, Math.round((img.naturalWidth || 2048) / (img.width || 700) * 100)));
    preview.style.backgroundSize = (ZOOM*100) + '%'; // use ZOOM fixed, or change to scalePct if you want auto
    preview.style.display = 'block';
    preview.setAttribute('aria-hidden', 'false');
    alignZoomToInfo(preview);
    __ensureLens();
    __showLens();
    const root = img.closest('.slider-images') || document;
    __getRootState(root).currentImg = img;
    return true;
  }

  function panelDetach(){
    if (!preview) return;
    preview.style.display = 'none';
    preview.style.backgroundImage = '';
    preview.setAttribute('aria-hidden', 'true');
    __hideLens();
  }

  function panelMove(img, e){
    if (!preview || preview.style.display === 'none') return;

    // 1) Relative position of the pointer within the image
    const t = e && (e.touches ? e.touches[0] : e);
    const { px, py } = posIn(img, t?.clientX ?? 0, t?.clientY ?? 0);

    // 2) Move the panel portion (you already had this)
    preview.style.backgroundPosition = `${(px*100).toFixed(2)}% ${(py*100).toFixed(2)}%`;

    // 3) Get current zoom factor to calculate lens size
    //    We try to read the computed background-size; if not, we use ZOOM.
    const r = img.getBoundingClientRect();
    const bs = getComputedStyle(preview).backgroundSize; // e.g. "220% 220%" o "800px 800px" o "220%"
    let scaleX, scaleY;

    if (bs && bs !== 'auto auto') {
      const parts = bs.split(' ');
      const parseVal = (v, fallback) => {
        if (!v) return fallback;
        if (v.endsWith('%')) return parseFloat(v) / 100;
        if (v.endsWith('px')) return parseFloat(v) / r.width; // px relative to the frame width
        // fallback: if it comes "auto" or other, use ZOOM
        return fallback;
      };
      // If only one value is given, we use the same for X and Y.
      scaleX = parseVal(parts[0], ZOOM);
      scaleY = parseVal(parts[1] ?? parts[0], ZOOM);
    } else {
      scaleX = ZOOM;
      scaleY = ZOOM;
    }

    // 4) Lens size so that the area it covers is EXACTLY what the panel shows.
    //    Formula: lens = frame / scale
    const lensW = r.width  / (scaleX || ZOOM);
    const lensH = r.height / (scaleY || ZOOM);

    // 5) Position the lens using the same percentages (px/py) as the panel
    //    and CLAMP it so it never leaves the <img> bounds (Amazon-like)
    const L = __ensureLens();
    L.style.width  = `${lensW}px`;
    L.style.height = `${lensH}px`;

    const halfW = lensW / 2;
    const halfH = lensH / 2;
    const cx = r.left + px * r.width;   // ideal center X (same % as panel)
    const cy = r.top  + py * r.height;  // ideal center Y (same % as panel)

    // Clamp center so lens stays inside the image rect
    const minX = r.left + halfW,  maxX = r.right  - halfW;
    const minY = r.top  + halfH,  maxY = r.bottom - halfH;
    const clampedCx = Math.max(minX, Math.min(maxX, cx));
    const clampedCy = Math.max(minY, Math.min(maxY, cy));

    L.style.left = `${clampedCx - halfW}px`;
    L.style.top  = `${clampedCy - halfH}px`;

    __showLens();
  }

  /* ============ OVERLAY MODE (fallback) ============ */
  function ensureRelative(el){
    if (!el) return;
    const s = getComputedStyle(el);
    if (s.position === 'static') el.style.position = 'relative';
    if (s.overflow === 'visible') el.style.overflow = 'hidden';
  }

  function makeOverlay(img){
    const o = document.createElement('div');
    const src = img.currentSrc || img.src || '';
    const big = hiRes(src) || src;
    o.className = 'image-magnify-full-size';
    o.style.position = 'absolute';
    o.style.inset = '0';
    o.style.zIndex = '10';
    o.style.pointerEvents = 'none';
    o.style.cursor = 'none';
    o.style.background = `url("${big}") no-repeat 50% 50% / ${ZOOM*100}%`;
    o.style.borderRadius = getComputedStyle(img).borderRadius;
    o.style.willChange = 'background-position';
    return o;
  }

  const state = new WeakMap(); // per image
  function getState(img){
    let s = state.get(img);
    if (!s) { s = { overlay: null, active: false, mode:'none' }; state.set(img, s); }
    return s;
  }

  function open(img, e){
    const s = getState(img);
    if (s.active) return;

    if (!img.complete || !(img.naturalWidth > 0)) {
      const once = () => { img.removeEventListener('load', once); open(img, e); };
      img.addEventListener('load', once, { once: true });
      return;
    }

    // 1) Try panel
    if (preview && panelAttach(img)){
      s.mode = 'panel';
      s.active = true;
      panelMove(img, e);
      return;
    }

    // 2) Fallback: overlay
    ensureRelative(img.parentElement);
    s.overlay = makeOverlay(img);
    img.parentElement.insertBefore(s.overlay, img.nextSibling);
    s.mode = 'overlay';
    s.active = true;
    move(img, e);
  }

  function close(img){
    const s = getState(img);
    if (!s.active) return;
    if (s.mode === 'panel'){
      panelDetach();
    } else if (s.mode === 'overlay'){
      s.overlay?.remove();
      s.overlay = null;
    }
    s.active = false;
    s.mode = 'none';
  }

  function move(img, e){
    const s = getState(img);
    if (!s.active) return;
    if (s.mode === 'panel') { panelMove(img, e); return; }
    if (s.mode === 'overlay' && s.overlay){
      const t = e && (e.touches ? e.touches[0] : e);
      const { px, py } = posIn(img, t?.clientX ?? 0, t?.clientY ?? 0);
      s.overlay.style.backgroundPosition = `${(px*100).toFixed(2)}% ${(py*100).toFixed(2)}%`;
    }
  }

  function closeAll(root){
    // close panel (if active) and overlays of any img
    panelDetach();
    root.querySelectorAll('img').forEach(close);
  }

  function bind(root){
    if (root.dataset.mzDelegated) return;
    root.dataset.mzDelegated = '1';

    const isDesktop = () => window.matchMedia('(pointer:fine)').matches;
    const activeImg = () => pickActiveImg(root);

    root.addEventListener('pointerenter', (e)=>{
      if (!isDesktop()) return;
      const img = imgUnderPointer(root, e); if (img) open(img, e);
    }, true);

    // We open on move if there is no zoom yet (for the case "I changed slides with the mouse inside")
    root.addEventListener('pointermove', (e)=>{
      if (!isDesktop()) return;
      const img = pickActiveImg(root);
      if (!img) { closeAll(root); return; }
      const s = getState(img);
      if (!s.active) open(img, e);
      move(img, e);
    }, true);

    root.addEventListener('pointerleave', ()=>{
      if (!isDesktop()) return;
      closeAll(root);
    }, true);

    // Mobile: tap-to-toggle + follow
    root.addEventListener('click', (e)=>{
      if (isDesktop()) return;
      const img = imgUnderPointer(root, e);
      if (!img) { closeAll(root); return; }
      const s = getState(img);
      if (!s.active) open(img, e); else close(img);
    }, true);

    root.addEventListener('touchmove', (e)=>{
      const img = imgUnderPointer(root, e);
      if (!img) { closeAll(root); return; }
      move(img, e);
    }, { passive: true });
  }

  function hookSwiper(root){
    // 1) Prioritizes the Swiper instance of this root
    const sc = root.querySelector('.swiper-container');
    const inst = sc && sc.swiper;
    if (inst && typeof inst.on === 'function') {
      inst.on('slideChange', () => closeAll(root));
    }

    // 2) (Optional) Supports a global Swiper if your theme exposes it
    const si = window.sliderImages;
    if (si && typeof si.on === 'function') {
      si.on('slideChange', () => closeAll(root));
    }
  }

  function observeSlides(root){
    const wrapper = root.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    const mo = new MutationObserver(()=> closeAll(root));
    mo.observe(wrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function init(){
    // Bind ALL main sliders in the page
    document.querySelectorAll('.slider-images').forEach((root) => {
      bind(root);
      hookSwiper(root);
      observeSlides(root);
    });
  }

  // Re-align zoom panel on scroll/resize if active
  ['scroll','resize'].forEach(evt=>{
    window.addEventListener(evt, ()=>{
      const panel = document.getElementById('zoom-container');
      if (!panel || panel.style.display === 'none') return;
      alignZoomToInfo(panel);
    }, { passive: true });
  });

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();